module.exports = __webpack_public_path__ + "static/website-dcbbf3b380f0ea1fe746e00d8f0313db.jpg";